import { i18n } from '@lingui/core'
import { z } from 'zod'

export const passwordPattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^\da-zA-Z]).{8,}$/

export const createPasswordValidation = () =>
  z
    .string({ required_error: i18n._('Passwort entspricht nicht den Anforderungen.') })
    .regex(passwordPattern, i18n._('Passwort entspricht nicht den Anforderungen.'))

export const createPasswordConfirmValidation = () =>
  z
    .string({ required_error: i18n._('Passwort wiederholen entspricht nicht den Anforderungen.') })
    .regex(passwordPattern, i18n._('Passwort wiederholen entspricht nicht den Anforderungen.'))

export const createLoginNameSchemaBase = () =>
  z
    .string({
      required_error: i18n._(
        'Der Loginname ist zu kurz. Unter dem Info-Button finden Sie eine Hilfestellung.'
      ),
    })
    .min(
      8,
      i18n._('Der Loginname ist zu kurz. Unter dem Info-Button finden Sie eine Hilfestellung.')
    )
    .max(
      10,
      i18n._('Der Loginname ist zu lang. Unter dem Info-Button finden Sie eine Hilfestellung.')
    )
    .refine((value) => /^\d+$/.test(value), i18n._('Der Loginname darf nur aus Nummern bestehen.'))
